import RencanaNilai from '../../../views/Kurikulum/RencanaNilai/RencanaNilai.view';

export default RencanaNilai;